import { render, staticRenderFns } from "./payGuide.vue?vue&type=template&id=1a5f339d&scoped=true&"
import script from "./payGuide.vue?vue&type=script&lang=js&"
export * from "./payGuide.vue?vue&type=script&lang=js&"
import style0 from "./payGuide.vue?vue&type=style&index=0&id=1a5f339d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f339d",
  null
  
)

export default component.exports